import React, { useState, useEffect } from 'react'
import { TextField, Button } from '@mui/material';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import * as Yup from 'yup';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import mail from '../../../../assets/images/contact/mail.png'
import checked from '../../../../assets/images/contact/checked.gif'
import Footer from '../Home/HomeComponents/Footer';
import { useSelector } from 'react-redux';

const ContactUs = () => {
    const {contact} = useSelector(state => state.configSlice);

    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const handleCloseModal = () => setShowModal(false);
    const navigate = useNavigate()
    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        email: Yup.string().email('Invalid email address').required('Email is required'),
        phone: Yup.string().required('Phone is required'),
        product: Yup.string().required('Product is required'),
        organization: Yup.string().required('Organization is required'),
        description: Yup.string().required('Description is required'),
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            phone: '',
            product: '',
            organization: '',
            description: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            try {
                // let { data } = await axios.post(`APIROUTE/api/contact/contact`, values, {
                //     headers: {
                //         "Authorization": "",
                //         "Content-Type": 'application/json'
                //     }
                // });
                resetForm();
                setShowModal(true);
                setLoading(true)
                setTimeout(() => {
                    setShowModal(false);
                    navigate('/home');
                }, 2500);
            } catch (error) {
                console.log(error)
            }
        },
    });

    useEffect(() => {
        const body = document.body;
        body.classList.remove("filter-active");
      }, []);

    return (
        <>
            <section className="banner contactbanner position-relative">
                <div className="container">
                    <div className="row justify-content-center position-relative z-1 mn2">
                        <div className="col-md-7 0ffset-md-2 text-center text-white">
                            <h1>Contact Us</h1>
                            <p className='opacity-5'>Start your skilling journey with AR VR enabled courses validated by industry specialists and subject matter expert.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contactus">
                <div className="container">
                    <div className="contcontstrt">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="card mb-4">
                                    <div className="card-body cbxdd">
                                        <img src={contact.image} alt="" />
                                        <h4 dangerouslySetInnerHTML={{ __html: contact.office}} />
                                        <p dangerouslySetInnerHTML={{ __html: contact.address}} />
                                    </div>
                                </div>
                                <div className="card mb-4">
                                    <div className="card-body cbxdd">
                                        <img src={mail} alt="" />
                                        <h4>Email</h4>
                                        <p><a href={`tel:${contact.email}`}>{contact.email}</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="card">
                                    <div className="card-body ">
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-6 mb-2">
                                                    <label>Name* </label>
                                                    <TextField
                                                        name="name"
                                                        type="text"
                                                        size='small'
                                                        placeholder="Name"
                                                        fullWidth
                                                        variant="outlined"
                                                        {...formik.getFieldProps('name')}
                                                        error={formik.touched.name && Boolean(formik.errors.name)}
                                                        helperText={formik.touched.name && formik.errors.name}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <label>Email* </label>
                                                    <TextField
                                                        name="email"
                                                        type="email"
                                                        size='small'
                                                        placeholder="Email"
                                                        fullWidth
                                                        variant="outlined"
                                                        {...formik.getFieldProps('email')}
                                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                                        helperText={formik.touched.email && formik.errors.email}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <label>Phone* </label>
                                                    <TextField
                                                        name="phone"
                                                        type="tel"
                                                        size='small'
                                                        placeholder="Phone"
                                                        fullWidth
                                                        variant="outlined"
                                                        {...formik.getFieldProps('phone')}
                                                        error={formik.touched.phone && Boolean(formik.errors.phone)}
                                                        helperText={formik.touched.phone && formik.errors.phone}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <label>Product* </label>
                                                    <TextField
                                                        name="product"
                                                        type="text"
                                                        size='small'
                                                        placeholder="Product"
                                                        fullWidth
                                                        variant="outlined"
                                                        {...formik.getFieldProps('product')}
                                                        error={formik.touched.product && Boolean(formik.errors.product)}
                                                        helperText={formik.touched.product && formik.errors.product}
                                                    />
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <label>Organization* </label>
                                                    <TextField
                                                        name="organization"
                                                        type="text"
                                                        size='small'
                                                        placeholder="Organization"
                                                        fullWidth
                                                        variant="outlined"
                                                        {...formik.getFieldProps('organization')}
                                                        error={formik.touched.organization && Boolean(formik.errors.organization)}
                                                        helperText={formik.touched.organization && formik.errors.organization}
                                                    />
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <label>Full description* </label>
                                                    <TextField
                                                        name="description"
                                                        type="text"
                                                        size='small'
                                                        placeholder="Include as much detail as you can"
                                                        fullWidth
                                                        variant="outlined"
                                                        multiline
                                                        rows={2}
                                                        {...formik.getFieldProps('description')}
                                                        error={formik.touched.description && Boolean(formik.errors.description)}
                                                        helperText={formik.touched.description && formik.errors.description}
                                                    />
                                                </div>
                                                <div className="col-md-12">
                                                    {/* <button className='btn btn-danger' variant="contained" disabled={formik.isSubmitting || !formik.isValid}> {loading ? 'Submit' : <><Spinner size='sm' />Submitting... </> </button> */}
                                                    <button className='btn btn-danger' variant="contained" disabled={formik.isSubmitting || !formik.isValid}>
                                                        {loading ? (<>  <Spinner size='sm' /> Submitting...  </>) : ('Submit')}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="map mb-5">
                <div className="container">
                    <div className="card">
                        <div className="card-body">
                            <iframe src={contact.coordinates} width="100%" height="400" style={{ border: '0', margin: '0px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </section>

            <Footer afooter="afooter" />

            <Modal centered show={showModal} onHide={handleCloseModal}>
                <Modal.Body className='thanksmodal'>
                    <img src={checked} alt="Thanks for contacting us" />
                    <h4>Thanks for contacting us</h4>
                    <p>A representative from our team will reach out to you shortly via email or phone.</p>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ContactUs
